import { apiURL } from "../constants/api"
import baseAPI from "./base"

const actualAPI = {
  getCurrentCount: () => baseAPI.get(apiURL.GET_CURRENT_COUNT),
  sendTestResult: (refer, answer, type, elapsedTime, lang) =>
    baseAPI.post(apiURL.SEND_TEST_RESULT, { refer, answer, type, elapsedTime, lang }),
}

const api = actualAPI

export default api
